import * as React from 'react';

import * as styles from './LocationModalContent.css';
import { TLocationModalStep } from '../../../../types/locationModal';
import { IRegion } from '../../../../types/regions';
import { MainRegions } from '../MainRegions';
import { RegionColumns } from '../RegionColumns';

interface ILocationModalContentProps {
  mainRegions: IRegion[];
  regionColumns: IRegion[][][];
  step: TLocationModalStep;
  currentRegion: IRegion;
  onRegionClick(region: IRegion): void;
}

export const LocationModalContent: React.FC<ILocationModalContentProps> = ({
  onRegionClick,
  regionColumns,
  step,
  mainRegions,
  currentRegion,
}) => {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    ref.current?.scrollTo(0, 0);
  }, [step]);

  return (
    <div ref={ref} className={styles['content']} data-testid="LocationModalContent">
      <MainRegions mainRegions={mainRegions} step={step} currentRegion={currentRegion} onRegionClick={onRegionClick} />
      <RegionColumns
        regionColumns={regionColumns}
        step={step}
        currentRegion={currentRegion}
        onRegionClick={onRegionClick}
      />
    </div>
  );
};
